import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/39.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Jarmark w Zagórowie"
            question="Dokąd pójdziesz najpierw?"
            audio={audio}
            answers={{
                ans1: "Na mały rynek.",
                ans2: "Na długi rynek.",
                ans3: "Na duży rynek."
            }}
            links={{
                link1: PAGES.p66,
                link2: PAGES.p67,
                link3: PAGES.p68
            }}
            content={
                <div>
                    <p>
                        Kiedy docieracie do Zagórowa, gęsiarz Stefan szybko zabiera swoje gęsi i biegnie z nimi na targ. Emil przełamuje się i pełen ciekawości zagaduje starego Tornaua, a ten pogodnie mu odpowiada. Postanawiasz przejść się po stoiskach i zobaczyć, na czym polega to Święto Dyszla, jak nazywają tutaj dzień targowy.
                    </p>
                    <ul>
                        <li>
                            Obejrzyj targ! A jak już ci się znudzi, znajdziesz nas u Jasińskiej – krzyczy na pożegnanie Emil. – Piwiarnia przy targu końskim! – dodaje, widząc twoje pytające spojrzenie.
                        </li>
                    </ul>
                </div>
            }
        />

    );
}